/*------------------------------------*\
    MODULES
\*------------------------------------*/
import { Fancybox } from "@fancyapps/ui";

/*------------------------------------*\
    MODAL GALLERY
\*------------------------------------*/
class ModalGallery {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const img = self.elem.querySelectorAll('[zoomed-img]');

        Fancybox.bind('[zoomed-img]');
        Fancybox.bind('[data-fancybox]');
    }
}

export default ModalGallery;